document.addEventListener('DOMContentLoaded', () => {
  const capabilityBtns = document.querySelectorAll('.capability');
  const capabilityInfos = document.querySelectorAll('.capability-info');
  const capabilityInfosContainer = document.querySelector('.capability-infos');
  const capabilityInfosBg = document.querySelector('.capability-infos-bg');
  const capabilityInfosCloseBtn = document.querySelector(
    '.capability-infos__btn'
  );

  document.querySelectorAll('.capability').forEach((capability) => {
    capability.addEventListener('click', () => {
      const capabilityId = capability.getAttribute('data-id');

      capabilityBtns.forEach((capabilityBtn) => {
        if (capabilityBtn.getAttribute('data-id') === capabilityId) {
          capabilityBtn.classList.add('capability--active');
        } else {
          capabilityBtn.classList.remove('capability--active');
        }
      });

      capabilityInfos.forEach((capabilityInfo) => {
        if (capabilityInfo.getAttribute('data-id') === capabilityId) {
          capabilityInfosContainer.hidden = false;
          capabilityInfosBg.classList.add('capability-infos-bg--active');
          capabilityInfo.hidden = false;
          setTimeout(() => {
            capabilityInfosContainer.style.height =
              capabilityInfo.offsetHeight + 'px';
          }, 100);
        } else {
          capabilityInfo.hidden = true;
        }
      });
    });
  });

  function closePopup() {
    capabilityInfosContainer.hidden = true;
    capabilityInfosBg.classList.remove('capability-infos-bg--active');
    capabilityBtns.forEach((capabilityBtn) => {
      capabilityBtn.classList.remove('capability--active');
    });
  }

  if (capabilityInfosBg) {
    capabilityInfosBg.addEventListener('click', () => {
      closePopup();
    });
  }

  if (capabilityInfosCloseBtn) {
    capabilityInfosCloseBtn.addEventListener('click', () => {
      closePopup();
    });
  }

  function initDots(dotClass) {
    const dots = Array.from(document.querySelectorAll(dotClass)).filter(
      (dot) => dot.offsetParent !== null
    );
    let activeDotIndex = 0;
    let prevActiveDotIndex = 0;

    function incrementActiveDot() {
      // const activeDot = dots[activeDotIndex];

      // activeDot.classList.remove('capability__dot--active');
      activeDotIndex = activeDotIndex + 1;
      if (activeDotIndex > dots.length - 1) activeDotIndex = 0;

      prevActiveDotIndex = activeDotIndex - 3;
      if (prevActiveDotIndex < -2) prevActiveDotIndex = dots.length - 3;
      if (prevActiveDotIndex < -1) prevActiveDotIndex = dots.length - 2;
      if (prevActiveDotIndex < 0) prevActiveDotIndex = dots.length - 1;

      if (dots[activeDotIndex])
        dots[activeDotIndex].classList.add('capability__dot--active');
      if (dots[prevActiveDotIndex])
        dots[prevActiveDotIndex].classList.remove('capability__dot--active');
    }

    setInterval(incrementActiveDot, 130);
  }

  initDots('.capability__line-dot');
  initDots('.capability__circle-dot');
});
